import {
  Center,
  CenterFeedPlacement,
  FeedOptions,
  Kevel_Zone_Ids
} from '@/types/models'

const addFeedTypeAndZoneId =
  ({ feedType, zoneId }: { feedType: FeedOptions; zoneId: Kevel_Zone_Ids }) =>
  (center: Center): Partial<CenterFeedPlacement> => {
    return {
      ...center,
      feedType,
      zoneId
    }
  }

export const addOrganicFeedTypeAndZoneId = addFeedTypeAndZoneId({
  feedType: FeedOptions.Organic,
  zoneId: Kevel_Zone_Ids.Organic
})

export const addLocalFeedTypeAndZoneId = addFeedTypeAndZoneId({
  feedType: FeedOptions.Local,
  zoneId: Kevel_Zone_Ids.Organic
})

export const addAdsTypeAndZoneId = addFeedTypeAndZoneId({
  feedType: FeedOptions.MidFeed,
  zoneId: Kevel_Zone_Ids.MidFeed
})

export const addNearbyFeedTypeAndZoneId = addFeedTypeAndZoneId({
  feedType: FeedOptions.Nearby,
  zoneId: Kevel_Zone_Ids.Organic
})
